import {Buffer} from 'buffer';

import { INFT } from '../Interfaces/NFT';
import { TOKEN_API } from '../Utils';
const requestNFT= async (token_id:string, serial: number): Promise <INFT> => {
    
    const tokenRequest = await fetch(
        TOKEN_API+token_id+'/nfts/'+serial
    ).then((response) => response.json());
    
     const token: INFT = {
         created_timestamp: tokenRequest.created_timestamp,
         token_id: tokenRequest.token_id,
         serial_number: tokenRequest.serial_number,
         name: tokenRequest.name,
         image: tokenRequest.image,
         account_id:tokenRequest.account_id,
         metadata: tokenRequest.metadata,
         description: tokenRequest.description
     };
     let metadata = Buffer.from(token.metadata, 'base64').toLocaleString();

        metadata = 'https://'+metadata+'.ipfs.nftstorage.link';

    const tokenData = await fetch(
        metadata
    ).then((response) => response.json());

   
    let image = tokenData.image;
    if(image.includes("ipfs://")){
        image = image.replace('ipfs://', 'https://ipfs.io/ipfs/');
        // console.log(image)
    }
    // console.log(date)
    const NFT:INFT = {
        token_id: token.token_id,
        serial_number: token.serial_number,
        name: tokenData.name,
        image: image,
        account_id: token.account_id,
        metadata: metadata,
        creator:tokenData.creator,
        description: tokenData.description,
    }
    return NFT
}

const requestImage= async (indexes:any): Promise <any> => {
    const images = [];
for (let index = 0; index < indexes.length; index++) {
    const element = indexes[index];
    const tokenRequest = await fetch(
        "https://bafybeihbb5efwyrwv53rad3qffxc7sasquqtflst2gqg3zs6ovlt6sqk2u.ipfs.nftstorage.link/"+element+".json"
    ).then((response) => response.json());
    images.push(tokenRequest.image)
    
}
    
 return images;
}

 

export { requestNFT, requestImage};
